import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import LandingPage from "./pages/landing";
import MainPage from "./pages/mainPaages/main";
import ServicesPage from "./pages/servicesPage";
import ProductsPage from "./pages/productsPage";
import ProjectsPage from "./pages/projectsPage";
import AboutUsPage from "./pages/aboutUsPage";
import Bitrix24Page from "./pages/bitrix24";
import FAQPage from "./pages/FAQ";

const App = () => {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/main" />} />
          <Route path="/landing" element={<LandingPage />} />
            <Route path="/main" element={<MainPage />} />
            <Route path="/main/services" element={<ServicesPage />} />
            <Route path="/main/products" element={<ProductsPage />} />
            <Route path="/main/projects" element={<ProjectsPage />} />
            <Route path="/main/about" element={<AboutUsPage />} />
          <Route path="/main/bitrix24" element={<Bitrix24Page />} />
          <Route path="/main/faq" element={<FAQPage />} />
        </Routes>
      </Router>
  );
};

export default App;
